jQuery(function ($) {

    function isValidEmailAddress(emailAddress) {
        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return pattern.test(emailAddress);
    }

    $('form').attr('autocomplete', 'off');

});

$forceconfirm = false;

function bannerswitch($this) {

    $(".banner-item").each(function (index) {
        $(this).hide();
    });
    $(".navitem").each(function (index) {
        $(this).removeClass("current");
    });

    var childnum = $this.data('banner-id');
    $(".bannercontainer").find(".banner-item:nth-child(" + childnum + ")").fadeIn("slow");
    $this.parent().find("[data-banner-id='" + childnum + "']").addClass("current");
}

function bannerrotate() {
    var $base2 = $("#bannercontainer");
    var count = $base2.children('.banner-item').length;
    $base2.children('.banner-item:visible').fadeOut(450, function (index) {
        var $next2 = $(this).next();
        var $i = $(this).data('banner-id');
        if ($i >= count) {
            $next2 = $('.banner-item').first();
        }
        $next2.fadeIn(450);
    });
}

// PREV/NEXT

function bannerPrev() {
  let $container = $("#bannercontainer");
  let count = $container.children('.banner-item').length;
  let $visible = $container.children('.banner-item:visible');
  let index = $visible.index();
  if (index == 0) {
      index = count;
  }
  index--;
  let $prev = $container.children('.banner-item').eq(index);
  $visible.fadeOut(450, function (i) {
      $prev.fadeIn(450);
  });
}

function bannerNext() {
  let $container = $("#bannercontainer");
  let count = $container.children('.banner-item').length;
  let $visible = $container.children('.banner-item:visible');
  let index = $visible.index();
  index++;
  if (index == count) {
      index = 0;
  }
  let $next = $container.children('.banner-item').eq(index);
  $visible.fadeOut(450, function (i) {
      $next.fadeIn(450);
  });
}

function setUrlParameter(paramName, paramValue) {
    var url = window.location.href;
    var hash = location.hash;
    url = url.replace(hash, '');
    if (url.indexOf(paramName + "=") >= 0) {
        var prefix = url.substring(0, url.indexOf(paramName));
        var suffix = url.substring(url.indexOf(paramName));
        suffix = suffix.substring(suffix.indexOf("=") + 1);
        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
        url = prefix + paramName + "=" + paramValue + suffix;
    }
    else {
        if (url.indexOf("?") < 0) { url += "?" + paramName + "=" + paramValue; }
        else { url += "&" + paramName + "=" + paramValue; }
    }
    return url + hash;
}

/*
function postbid(context) {
  socket.emit('postbid', context);
}

socket.on('refreshlisting', function (ret) {
  refreshlisting(ret.context, false);
});
*/

function global_alert(message, type, delay) {
    var $this = $('.staticalerts'),
        alert_class;

    $this.slideDown();
    if (delay === undefined) { delay = 10000; }

    if (type) { alert_class = 'alert-' + type; }
    else { alert_class = 'alert-info'; }

    var element = $('<div/>').addClass('alert').addClass(alert_class).html(message).append('<a class="close" data-dismiss="alert">&times;</a>').prependTo($this);

    element.hide().slideDown();
    if (delay) { element.delay(delay).slideUp(function () { $(this).remove(); }); }
    return this;
}

function updatePendingBidCount() {
    var $pendingcount = $('.actionfield input.dollar.pending:not([readonly]):not(.persistent)').length;
    $pendingcount += $('.offeractions .counterform input.dollar.pending:not([readonly]):not(.persistent)').length
    if (parseInt($pendingcount) > 0) {
        $('.pendingbidcount').text($pendingcount);
        if ($('.pendingbidcount').hasClass('hide')) {
            $('.pendingbidcount').removeClass('hide');
        }
    }
    else {
        $('.pendingbidcount').text('0');
        $('.pendingbids .pendingtotal').val('$0');
        if (!$('.pendingbidcount').hasClass('hide')) {
            $('.pendingbidcount').addClass('hide');
        }
    }
}

function refreshlisting(ret, ended = false, finalcheck = false, noflash = false, consignment_sold = false) { // refresh auction status

    var context = ret,
        par = $('.listingbox[data-context="' + context + '"]');
    var dataString = 'context=' + context + '&consignment_sold=' + consignment_sold + '&x_sign=' + x_sign + '&x_it=' + x_it,
        messagebox = par.find('.message'),
        loader = par.find('.loader'),
        cntr = par.find('.countdown-container');
    if (par.length) {

        $.ajax({
            type: "POST",
            url: "/sec_ajax/listingstatus",
            data: dataString,
            cache: false,
            success: function (response) {

                var obj = $.parseJSON(response);

                if (obj.ERR) {
                    //messagebox.text(obj.ERR);
                    global_alert(obj.ERR, 'error');
                } else if (obj.RET) {

                    if (obj.RET.started === false) {
                        par.find('.auctionactions').hide();
                        par.find('.actionbtn').hide();
                        par.find('.detailsbtn').show();
                        par.find('.auctionstartsinmsg').text('AUCTION STARTS IN')

                    }
                    else {
                        par.find('.auctionactions').show();
                        par.find('.actionbtn').show();
                        par.find('.detailsbtn').hide();
                        par.find('.auctionstartsinmsg').text('AUCTION ENDS IN')
                    }

                    if (obj.RET.sold === true) {
                        par.find('.actionfield').remove();
                        par.find('.btn.exec').remove();
                        par.find('.delistbutton').remove();
                        cntr.attr('data-countdown-ends', '0'); // forces timer change (bug)
                        cntr.countdown('stop');

                        par.find('.timercont').hide();
                    }

                    var msgtext = obj.RET.MSG;

                    if (msgtext) {
                        messagebox.text(msgtext);
                        if (obj.RET.MSGC) {
                            messagebox.css('color', obj.RET.MSGC);
                        }
                        else {
                            messagebox.css('color', '#49b94b');
                        }

                        if (obj.RET.THEHIGHBIDDER == '1') {
                            par.find('.nextbidmsg').addClass('hide');
                        }
                        else {
                            par.find('.nextbidmsg').removeClass('hide');
                        }
                    }

                    if (obj.RET.label_price) {
                        par.find('.pricing .lbl').text(obj.RET.label_price);
                    }
                    var pricearea = par.find('.val.prc'),
                        incrarea = par.find('.val.incr'),
                        pricecolor = pricearea.css('color'),
                        incrcolor = incrarea.css('color');

                    if (obj.RET.eb == '1') {
                        cntr.addClass('final');
                    }

                    if (obj.RET.ms) {
                        /*
            if (obj.RET.ms <= 250000)
            {
              cntr.attr('data-countdown-ends', '180001'); // forces timer change
            }
            cntr.countdown('start');
            */
                        cntr.attr('data-countdown-ends', obj.RET.ms);
                        cntr.countdown('update');
                        cntr.countdown('update');

                        setTimeout(function () {
                            cntr.attr('data-countdown-ends', (obj.RET.ms - 1));
                            cntr.countdown('update');
                        }, 100);
                    }

                    if (obj.RET.bid_count != par.find('.val.incr').text()) {
                        if (obj.RET.eb == '1') {
                            par.find('.val.prc').animate({ color: "#bf0000" }, 400);
                            par.find('.val.incr').animate({ color: "#bf0000" }, 400);
                        }
                        else {
                            par.find('.val.prc').animate({ color: "#3887fe" }, 400);
                            par.find('.val.incr').animate({ color: "#3887fe" }, 400);
                        }

                        par.find('input.value').addClass('flashme');

                        setTimeout(function () {
                            par.find('input.value').removeClass('flashme');
                            par.find('.val.prc').css('color', pricecolor);
                            par.find('.val.incr').css('color', incrcolor);
                        }, 800);
                    }

                    par.find('.val.prc').text(obj.RET.lastbid_amount);
                    par.find('.val.incr').text(obj.RET.bid_count);

                    if (obj.RET.nextbid) {
                        par.find('.actionfield .nextbidmsg .minbidvalue').text(obj.RET.nextbid);

                        var thenextbid = 0;
                        if (obj.RET.THEHIGHBIDDER != '1') {
                            thenextbid = obj.RET.nextbid;
                        }

                        par.find('.actionfield[data-type="bid"] .value').data('min', thenextbid);
                    }
                    else {
                        par.find('.actionfield[data-type="offer"] .value').val('$');
                        par.find('.actionfield[data-type="offer"] .value').removeClass('pending').removeClass('failed');
                    }

                    if (obj.RET.SHOWCOUNTER) {
                        par.find('.offeractions').html(obj.RET.SHOWCOUNTER);
                    }

                    if (obj.RET.SHOWCOUNTER) {
                        par.find('.offeractions').html(obj.RET.SHOWCOUNTER);
                    }

                    if (obj.RET.datestring) {
                        par.find('.datetime').html(obj.RET.datestring);
                    }

                    if (obj.RET.bidsnapshot) {
                        par.find('.togglebidsnapshot').replaceWith(obj.RET.bidsnapshot);
                    }

                    if (obj.RET.reserve_text) {
                        par.find('.reserve').html(obj.RET.reserve_text);
                    }

                    if (ended == true) {
                        if (finalcheck !== true) {
                            //refreshlisting(ret);
                            setTimeout(function () {
                                refreshlisting(ret, true, true);
                            }, 500);
                        }

                        if (finalcheck == true && obj.RET.ENDED == true) {
                            if (obj.RET.minibuttons) {
                                par.find('.buttons').html(obj.RET.minibuttons);
                            }

                            if (parseInt(obj.RET.bid_count) > 0) {
                                par.find('.pricing .lbl').text('Sold For');
                            }
                            else {
                                par.find('.pricing .lbl').text('Starting Bid');
                            }

                            par.find('.countdown-container').hide();
                            par.find('.auctionstartsinmsg').hide();
                            par.find('.auctionactions').hide();
                            par.addClass('grey');
                            messagebox.addClass('bigger');
                        }
                    }

                }
                updatePendingBidCount();
                //updatependingbids();
                loader.hide();
            }
        });

    }

}

function togglesignup(thestate) {
    if (!$(".signupoverlay").is(":visible")) {
        $(".globaloverlay").addClass('forceshow');
        $(".signupoverlay").addClass('forceshow');
    }

    switch (thestate) {
    case 'join':
        $(".globaloverlay").addClass('forceshow');
        $(".presignup").addClass('forceshow');
        $("#signup-toggle").removeClass('inactive');
        $("#login-toggle").addClass('inactive');
        $(".login-div").removeClass('forceshow');
        $(".signup-div").addClass('forceshow');
        break;
    case 'login':
        $(".globaloverlay").addClass('forceshow');
        $(".presignup").addClass('forceshow');
        $("#signup-toggle").addClass('inactive');
        $("#login-toggle").removeClass('inactive');
        $(".signup-div").removeClass('forceshow');
        $(".login-div").addClass('forceshow');
        break;
    case 'jointoggle':
        $(".globaloverlay").addClass('forceshow');
        $(".presignup").addClass('forceshow');
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        $("#signup-toggle").toggleClass('inactive');
        $("#login-toggle").toggleClass('inactive');
        $(".signup-div").toggleClass('forceshow');
        $(".login-div").toggleClass('forceshow');
        break;
    case 'hide':
        $(".globaloverlay").removeClass('forceshow');
        $(".signupoverlay").removeClass('forceshow');
        $(".presignup").removeClass('forceshow');
        $(".signup").removeClass('forceshow');
        break;
    }
}

function adjustheights() {
    // var windowWidth = $(window).width();
    // var filtersHeight = $('.browselistings .filters').height();
    // if(windowWidth >= 950) {
    // 	setTimeout(function(){
    // 		$('.browselistings').height(filtersHeight);
    // 	}, 1000);
    // }

    var parcont = $('.browselistings'),
        parheight = parcont.height(),
        filtercont = parcont.find('.filters'),
        filterheight = filtercont.height();

    if (parheight > filterheight) {
        filtercont.height(parheight);
    }
    else if (filterheight > parheight) {
        parcont.height(filterheight);
    }
}

$(window).on('load', function () {

    setTimeout(function () {
        $(".staticalerts").hide('blind', {}, 1400);
    }, 4000);

    // Sync timers on page load
    $('.listingbox[data-type="auction"][bp="true"]').each(function () {
        var context = $(this).data('context');
        setTimeout(function () {
            refreshlisting(context, false, false, false, false);
        }, 1000);
    });

    $('.listingbox[data-type="auction"]').not('[bp]').each(function () {
        var context = $(this).data('context');
        setTimeout(function () {
            refreshlisting(context, false, false, false, false);
        }, 1000);
    });

    $('.listingbox[data-type="auction"][bp="false"]').each(function () {
        var context = $(this).data('context');
        setTimeout(function () {
            refreshlisting(context, false, false, false, true);
        }, 1000);
    });

    if ($('.browseckey').length) {

        var search = $('.filters').find('input[name="search"]').val(),
            sortType = $('.filters').find('input[name="sortType"]').val(),
            pathzero = $('.filters').find('input[name="pathzero"]').val(),
            pathone = $('.filters').find('input[name="pathone"]').val(),
            pathtwo = $('.filters').find('input[name="pathtwo"]').val(),
            browseckey = $('.filters').find('input[name="browseckey"]').val(),
            cacheHtml = $('.filters').find('input[name="cacheHtml"]').val(),
            theurl = $('.filters').find('input[name="theurl"]').val(),
            filter_prefix = $('.filters').find('input[name="filter_prefix"]').val(),
            get_params = window.location.search.substring(1);
        var dataString = 'browseckey=' + browseckey + '&cacheHtml=' + cacheHtml + '&search=' + search + '&sortType=' + sortType + '&pathzero=' + pathzero + '&pathone=' + pathone + '&pathtwo=' + pathtwo + '&theurl=' + theurl + '&filter_prefix=' + filter_prefix + '&x_sign=' + x_sign + '&x_it=' + x_it + '&' + get_params;

        $.ajax({
            type: "POST",
            url: "/sec_ajax/showfilters",
            data: dataString,
            cache: false,
            success: function (response) {

                if (response === 'null') {
                    $('.filters').find('.filtercontainer').html('');
                    return false;
                }
                else {
                    $('.filters').find('.filtercontainer').html(response);
                    var fActive = $('body .filters .filtersactive').outerHeight();
                    $('body .listingsgrid').css('min-height', $('body .filtercontainer').outerHeight()
            + (2 * $('body .filters .head').outerHeight())
            + $('body .filters .filtersec').outerHeight() + (typeof fActive === 'undefined' ? 0 : fActive) + 38)
                        .css('display', 'block');
                }

                setTimeout(function () {
                    adjustheights();
                    $('.browselistings').css('height', '100%');
                }, 1000);
            }
        });
    }

});

function updatependingbids() {

    var dataString = 'x_sign=' + x_sign + '&x_it=' + x_it;

    $.ajax({
        type: "POST",
        url: "/sec_ajax/pendingbidstally",
        data: dataString,
        cache: false,
        success: function (response) {

            var obj = $.parseJSON(response);

            if (parseInt(obj.COUNT) > 0) {
                $('.pendingbidcount').text(obj.COUNT);
                if ($('.pendingbidcount').hasClass('hide')) {
                    $('.pendingbidcount').removeClass('hide');
                }

                $('.pendingbids .confirmbox .thecnt').text(obj.COUNT);
            }
            else {
                if (!$('.pendingbidcount').hasClass('hide')) {
                    $('.pendingbidcount').addClass('hide');
                }

                $('.pendingbids .confirmbox .thecnt').text('0');
            }

            /*
      var $thetotal = obj.TOTAL;

      if ($thetotal)
      {
        var $ret = $thetotal.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        $('.pendingbids .pendingtotal').val('$'+$ret);
      }
      */
        }
    });
}

$(document).ready(function () {

    $('.next_btn[data-submit="sellitem"]').on('click', function () {
        $('#loading').show();
    });

    $(".actionfield input.dollar:not([readonly])").each(function (i) { $(this).attr('tabindex', i + 1); });

    /*
  $('.actionfield input.dollar:not([readonly])').keypress(function (event) {
        if (event.keyCode == '13') {
            event.preventDefault();
            $(this).parent().find('.exec.active').trigger('click');
        }
    });
    */

    $('.fieldsection select').on('change', function (e) {
        e.preventDefault();
    });

    // START: BANNER SLIDER

    // Initialize nav
    // $(".banner-item").each(function (index) {
    //     if (index == 0) {
    //         $(".bannernav ul").append('<li class="current navitem" data-banner-id="' + (index + 1) + '"><div></div></li>');
    //     }
    //     else {
    //         $(".bannernav ul").append('<li class="navitem" data-banner-id="' + (index + 1) + '"><div></div></li>');
    //     }
    // });

    $(".navitem").click(function () {
        bannerswitch($(this));
    });

    if ($('.bannercontainer ul li').length > 1) {

        var bannerint = setInterval(bannerrotate, 6500);

        $('.bannercontainer').mouseover(function () {
            clearInterval(bannerint);
        }).mouseout(function () {
            bannerint = setInterval(bannerrotate, 6500);
        });
    }

    // END: BANNER SLIDER

    $(this).on('click', '.deleteallmsgs', function () {
        var r = confirm("Are you sure you would like to delete all checked messages?");
        var searchIDs = '';
        if (r == true) {
            searchIDs = $(".selectrow:checked").map(function () {
                return $(this).data('id');
            }).get();

            var dataString = 'searchIDs=' + JSON.stringify(searchIDs) + '&x_sign=' + x_sign + '&x_it=' + x_it;

            $.ajax({
                type: "POST",
                url: "/sec_ajax/deletedcheckedmsgs",
                data: dataString,
                cache: false,
                success: function (response) {
                    if (response) {
                        window.location.href = '/dashboard?delallmsg=1';
                    }
                    return false;
                }
            });

        } else {
            return false;
        }

    });

    $(this).on('click', '.selectallmsgs', function () {
        var ischecked = false,
            spantext = 'Select';
        if ($(this).hasClass('active')) {
            $(this).removeClass('active').addClass('grey').removeClass('blue');
            $(this);
        }
        else {
            $(this).addClass('active').addClass('blue').removeClass('grey');
            ischecked = true;
            spantext = 'Selected';
        }
        $('.selectrow').not(this).prop('checked', ischecked).siblings('span').text(spantext);

    });

    $(this).on('click', '.selectrow', function () {
        var spantext = 'Select';
        if ($(this).is(':checked')) {
            spantext = 'Selected';
        }

        $(this).siblings('span').text(spantext);
    });

    $('.dashboardcounts .cnt.loading').each(function () {
        var type = $(this).data('type'),
            $this = $(this);

        if ($this.length) {
            var dataString = 'type=' + type + '&x_sign=' + x_sign + '&x_it=' + x_it;

            $.ajax({
                type: "POST",
                url: "/sec_ajax/dashboardcount",
                data: dataString,
                cache: false,
                success: function (response) {
                    if (response) {
                        $this.text(response).removeClass('loading');
                    }
                    return false;
                }
            });
        }
    });

    $('.watch-btn').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $this = $(this),
            $context = $this.parents('.whitedropmenu').data('context');

        var dataString = 'context=' + $context + '&x_sign=' + x_sign + '&x_it=' + x_it;

        $.ajax({
            type: "POST",
            url: "/sec_ajax/togglewatchlist",
            data: dataString,
            cache: false,
            success: function (response) {
                var obj = $.parseJSON(response);

                if (obj.STATUS) {
                    if (obj.STATUS == 'notloggedin') {
                        global_alert("You must be logged in first to do this.", 'error');
                        return false;
                    }
                    else if (obj.STATUS == 'added') {
                        $this.addClass('active').text('REMOVE WATCH LIST');
                    }
                    else {
                        $this.removeClass('active').text('ADD WATCH LIST');
                    }
                }

            }
        });
    });

    $(this).on('click', '.listingsmenu', function (e) {
        $('.whitedropmenu').hide().removeClass('active');
        e.stopPropagation();
        if ($(this).hasClass('active')) {
            $(this).find('.whitedropmenu').hide();
            $(this).removeClass('active');
        }
        else {
            $(this).find('.whitedropmenu').show();
            $(this).addClass('active');
        }
    });
    $(this).click(function () {
        $('.whitedropmenu').hide().removeClass('active');
    });

    $(this).on('keyup', '.actionfield input.dollar.persistent:not([readonly])', function () {
        var $this = $(this),
            $theval = $this.val();
        $context = $this.parents('.actionfield').data('context');

        var dataString = 'theval=' + $theval + '&context=' + $context + '&x_sign=' + x_sign + '&x_it=' + x_it;
    });

    $

    $(this).on('keyup', '.actionfield input.dollar.persistent:not([readonly])', function () {
        var $this = $(this),
            $theval = $this.val();
        $context = $this.parents('.actionfield').data('context');

        var dataString = 'theval=' + $theval + '&context=' + $context + '&x_sign=' + x_sign + '&x_it=' + x_it;

        $(this).removeClass('fail');

        $.ajax({
            type: "POST",
            url: "/sec_ajax/pendingbid",
            data: dataString,
            cache: false,
            success: function (response) {

                var obj = $.parseJSON(response);

                if (obj.STATUS) {
                    if (obj.STATUS == 'removed') {
                        $this.attr('class', 'dollar value');
                    }
                    else {
                        $this.addClass(obj.STATUS);
                    }

                    if (parseInt(obj.COUNT) > 0) {
                        $('.pendingbidcount').text(obj.COUNT);
                        if ($('.pendingbidcount').hasClass('hide')) {
                            $('.pendingbidcount').removeClass('hide');
                        }

                        $('.pendingbids .confirmbox .thecnt').text(obj.COUNT);
                    }
                    else {
                        $('.pendingbidcount').text('0');
                        $('.pendingbids .pendingtotal').val('$0');
                        if (!$('.pendingbidcount').hasClass('hide')) {
                            $('.pendingbidcount').addClass('hide');
                        }

                        $('.pendingbids .confirmbox .thecnt').text('0');
                    }

                    /*
          if (obj.TOTAL)
          {
            var $thetotal = obj.TOTAL;
            var $ret = $thetotal.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            $('.pendingbids .pendingtotal').val('$'+$ret);
          }
          */
                }
            }
        });
    });
    var timerId;
    $(this).on('input', '.actionfield input.dollar:not([readonly]):not(.persistent)', function (e) {
        var $this = $(this),
            $context = $this.parents('.actionfield').data('context');

        var chars = $(this).val().split('');
        if (chars[0] != '$') {
            var currentValue = $(this).val();
            if (currentValue.indexOf('$') != -1) {
                $(this).val('$' + currentValue.substr(0, currentValue.indexOf('$')));
            }
            else {
                $(this).val('$');
            }
        }

        var regex = new RegExp('[^0-9$]');

        if (regex.test($this.val()) && (!timerId || timerId === 0)) {
            timerId = setTimeout(function () {
                var index = $this.val().indexOf('.');

                if (index !== -1) {
                    $this.val($this.val().substr(0, index));
                }
                else {
                    $this.val($this.val().replace(/[^0-9$]/g, ''));
                }
                $(".dollarError", $this.parents('.actionfield')).show();
                timerId = 0;
            }, 750)
            return;
        }
        $theval = $this.val().replace(/[^0-9]/g, '');

        $(this).removeClass('fail');
        $(".dollarError", $this.parents('.actionfield')).hide();

        if ($theval.length <= 0) {
            $this.attr('class', 'dollar value');
        }
        else {
            $this.addClass('pending');
        }

        updatePendingBidCount();
        /*
    $pendingtotal = 0;
    var $ret = '$0';

    $('.actionfield input.dollar.pending:not([readonly]):not(.persistent)').each(function() {
      if ($(this).val().length)
      {
        $theval = $(this).val().replace(/[^0-9\.]/g, '');
        $pendingtotal = parseFloat(parseFloat($pendingtotal) + parseFloat($theval));
        $pendingtotal = String($pendingtotal);
        $ret = $pendingtotal.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        $('.pendingbids .pendingtotal').val('$'+$ret);
      }
    });
    */

        var $bidcount = $('.actionfield input.dollar.pending:not([readonly]):not(.persistent)').length;

        $('.pendingbids .thecnt').text(String($bidcount));

    });
    $(this).on('input', '.counterform input.dollar:not([readonly]):not(.persistent)', function (e) {
        var $this = $(this),
            $context = $this.parents('.itempreview.listingbox').data('context');
        var regex = new RegExp('[^0-9$]');

        if (regex.test($this.val()) && (!timerId || timerId === 0)) {
            timerId = setTimeout(function () {
                var index = $this.val().indexOf('.');

                if (index !== -1) {
                    $this.val($this.val().substr(0, index));
                }
                else {
                    $this.val($this.val().replace(/[^0-9$]/g, ''));
                }
                $(".dollarError", $this.parents('.actionfield')).show();
                timerId = 0;
            }, 750)
            return;
        }
        $theval = $this.val().replace(/[^0-9]/g, '');

        $(this).removeClass('fail');
        $(".dollarError", $this.parents('.actionfield')).hide();

        if ($theval.length <= 0) {
            $this.attr('class', 'dollar value');
        }
        else {
            $this.addClass('pending');
        }

        updatePendingBidCount();
    });

    if ($(window).width() > 600) {
        $(this).on('mouseenter', '.nextauction .auctionsessions', function () {
            $(this).addClass('toggleshow');
            //$(this).siblings('.timer').addClass('toggleshow');
        }).on('mouseleave', '.nextauction .auctionsessions', function () {
            $(this).removeClass('toggleshow');
            //$(this).siblings('.timer').removeClass('toggleshow');
        });
    }

    $(this).on('change', '.advanced-search-box select', function () {
        if ($(this).prop('selectedIndex') === 0) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });

    $(this).on('click', '.descrlink', function () {
        $('html, body').animate({
            scrollTop: $('.descriptiontab:visible:first').offset().top
        }, 1000);
    });

    /*
  $(this).on('click', '.barbutton.pendingbids' ,function() {
    $(this).find('.pendingbidspop').toggle();
  });
  */

    // FOR CHECKOUT AND SELL ITEMS
    $(this).on('click', '.radioitem', function () {
        var $radiotype = $(this).data('radio-type'),
            $radioval = $(this).data('value'),
            $par = $(this).parents('.customradio');

        $('.radioitem[data-radio-type="' + $radiotype + '"]').removeClass('active');
        $par.find('input[name="' + $radiotype + '"]').val($radioval);
        $(this).addClass('active');

        // show selected secondary fields
        $par.nextAll('.secondarysection:first').children().hide();
        $par.nextAll('.secondarysection:first').find('.fieldsection[data-type="' + $radioval + '"]').show().css({ visibility: 'visible', position: 'relative' });

        $('.inlinefield[data-toggle="' + $radiotype + '"]').each(function () {
            if ($(this).data('hide') == $radioval) {
                $(this).hide();
            }
            else {
                $(this).show();
            }
        });

        $('input[data-readonly="' + $radiotype + '"]').each(function () {

            if ($(this).data('read') == $radioval) {
                $(this).prop('readonly', true).val($(this).data('default'));
            }
            else {
                $(this).prop('readonly', false).val($(this).data('default'));
            }
        });

        if ($(this).hasClass('maintype')) {
            if ($(this).data('value') == '1') {
                $('.whitebox.onlycomic').show();
                $('.whitebox .onlycomic').show();
                $('.whitebox.onlyvideogame').hide();
                $('.whitebox .onlyvideogame').hide();
            }
            else if ($(this).data('value') == '5') {
                $('.whitebox.onlyvideogame').show();
                $('.whitebox .onlyvideogame').show();
                $('.whitebox.onlycomic').hide();
                $('.whitebox .onlycomic').hide();
                $('#issue_number').val('0');
            }
            else {
                $('.whitebox.onlyvideogame').hide();
                $('.whitebox .onlyvideogame').hide();
                $('.whitebox.onlycomic').hide();
                $('.whitebox .onlycomic').hide();
            }
        }

    });

    $(this).on('mouseenter', '.togglemenu', function () {
        $(this).children('.dropmenu').stop().slideDown(200);
    }).on('mouseleave', '.togglemenu', function () {
        $(this).children('.dropmenu').stop().slideUp(200);
    }).on('click', '.togglemenu', function () {
        $(this).children('.dropmenu').stop().slideToggle(200);
    });

    // resize tall coverart
    // $('.listingbox .mainimg img').each(function () {
    // 	var img = $(this);
    // 	var parentHeight = img.closest('.mainimg').height(); //max height
    //
    // 	if (img.height() > parentHeight){
    // 		img.addClass('taller');
    // 	}
    // });

    $(this).on('click', '.togglesignup', function (e) {
        e.preventDefault();
        togglesignup($(this).data('type'));
    });

    $(this).on('click', '.filtersec .toggleit', function (e) {
        e.preventDefault();
        $(this).closest('.filtersec').toggleClass('closed');

        var fActive = $('body .filters .filtersactive').outerHeight();
        $('body .listingsgrid').css('min-height', $('body .filtercontainer').outerHeight()
      + (2 * $('body .filters .head').outerHeight())
      + $('body .filters .filtersec').outerHeight() + (typeof fActive === 'undefined' ? 0 : fActive) + 38)
            .css('display', 'block');

        setTimeout(function () {
            adjustheights();
            $('.browselistings').css('height', '100%');
        }, 1000);
    });

    $(this).on('click', '.closeme', function () {
        $('.globaloverlay').removeClass('forceshow');
        $(this).parents('.closeparent').removeClass('forceshow');
    });

    // Adjust currency on typing bid amount
    $(this).on('change', 'input.dollar.value:not([readonly])', function (e) {
        if (e.which != 8) {
            var par = $(this).parents('.listingbox');
            // skip for arrow keys
            if (e.which >= 37 && e.which <= 40) return;
            // format number

            $(this).val(function (index, value) {
                var $ret = value;
                var index = value.indexOf('.');
                if (index !== -1) {
                    $ret = value.substr(0, index).replace(/[^0-9]/g, '');
                }
                else {
                    $ret = value.replace(/[^0-9]/g, '');
                }

                return '$' + $ret;
            });

            if (e.which == 13) {
                par.find('.exec.active').click();
                return false;
            }
        }
    });

    // submit bid when hitting enter.
    // Alternatively, capture tabbing through fields and prevent the default behavior of highlighting the entire price. - AaW
    $(this).on('keyup', 'input.dollar.value:not([readonly])', function (e) {
        if (e.which == 13) {
            var val = $(this).val().replace(/[^0-9]/g, '');
            if (val) {
                var par = $(this).parents('.listingbox');
                par.find('.exec.active').click();
                return false;
            }
            else {
                $(this).removeClass('pending');
            }
        }
        if (e.which == 9) {
            this.selectionStart = this.selectionEnd = this.value.length;
        }
    });

    $(this).on('focus', '.thefield input', function (e) {
        $('.exec').each(function () {
            $(this).removeClass('active');
        });
        $(this).siblings('.exec').addClass('active');
    });

    $(this).on('mouseenter', '.togglebidsnapshot', function (e) {
        $(this).find('.bidsnapshot').show();
    }).on('mouseleave', '.togglebidsnapshot', function (e) {
        $(this).find('.bidsnapshot').hide();
    });

    // prevent gallery thumbs on hover
    $(this).on('mouseenter', '.photogal .coverthumb', function (e) {
        var selected = $(this).attr('data-src'),
            image = $(this).closest('.photogal').find('.mainimg img'),
            cursrc = image.attr('src');
        if (cursrc != selected) {
            image.fadeOut('fast', function () {
                image.attr('src', selected);
                if (selected.indexOf('/scans/') > -1) {
                    $('.mainarea .refnotice').show();
                }
                else {
                    $('.mainarea .refnotice').hide();
                }
                $('.dzlightbox.mainimg').attr('href', selected);
                image.fadeIn('fast');

            });
        }
        return false;
    });

    if ($(window).width() > 600) {
        $(this).on('click', '.dzlightbox.mainimg', function () {
            $('.globaloverlay').html('').css({ height: $(document).height() }).addClass('lightboxversion').prepend('<div class="dzlightbox"><div class="closeit"></div><img id="theImg" src="' + $(this).attr('href') + '" />').show();
            window.scrollTo(0, 0);
        });
    }

    $(this).on('click', '.globaloverlay.lightboxversion, .globaloverlay.lightboxversion .closeit', function () {
        $('.globaloverlay').html('').css({ height: '100%' }).removeClass('lightboxversion').hide();
    });

    $(this).on('click', '.globaloverlay.lightboxversion .dzlightbox', function (e) {
        e.stopPropagation();
    });

    $(this).on('click', '.zoom-button', function (e) {
        $('.dzlightbox.mainimg').click();
    });

    // cancel pending bids
    $(this).on('click', '.exec[data-conf="cancelbids"]', function (e) {
        e.preventDefault();
        //location.reload();
        $('.dollar.value.pending').each(function () {
            $(this).val('$');
            $(this).removeClass('pending');
        });

        $('.pendingbidcount').text('0');
        $('.pendingbids .pendingtotal').val('$0');
        if (!$('.pendingbidcount').hasClass('hide')) {
            $('.pendingbidcount').addClass('hide');
        }

    /*par = $(this).parents('.clearall');

    var thisAuctionConfirmPromise = $.Deferred();
    thisAuctionConfirmPromise.then(thisAuctionConfirmPromiseResolved, function(){loader.hide();});

    if (confirm)
    {
      par.find('.fulloverlay').show();

      par.find('.fulloverlay button[data-action="confirm"]').on('click', {promise: thisAuctionConfirmPromise}, function(event){
        event.data.promise.resolve();
        par.find('.fulloverlay').hide();
      });
      par.find('.fulloverlay button[data-action="cancel"]').on('click', function(){
        par.find('.fulloverlay').hide();
      });
    } else {
      thisAuctionConfirmPromise.resolve();
    }

    function thisAuctionConfirmPromiseResolved() {
      var dataString ='x_sign='+x_sign+'&x_it='+x_it;

      $.ajax({
      type: "POST",
      url: "/sec_ajax/cancelpendingbids",
      data: dataString,
      cache: false,
      success: function(response)
      {
        if (response)
        {
          $('.listingsgrid').replaceWith('<div class="noresults">No results found. Check back later.</div>');
          $('.pendingcnt').text('0');
          global_alert('All pending bids and offers have been cleared..', 'success');
        }
      }
      });
    }
    */
    });

    // place all bids
    $(this).on('click', '.exec[data-conf="bidall"]', function (e) {
        e.preventDefault();
        var rawvalue = $('.pendingcnt').text(),
            pendingbidcount = $('.pendingbidcount').text(),
            // pending offer count
            par = $('#confirmall'),
            confmsg = par.find('.fulloverlay').find('.confirmbox .msg'),
            confmsgtext = confmsg.text(),
            pendingtotal = par.find('.pendingtotal').val();

        var thisAuctionConfirmPromise = $.Deferred();
        thisAuctionConfirmPromise.then(thisAuctionConfirmPromiseResolved, function () { loader.hide(); });

        if (pendingbidcount > 0) {
            if (confirm) {
                par.find('.fulloverlay').show();
                //confmsg.find('span.thecnt').text(rawvalue);
                //confmsg.find('span.thetotal').text(pendingtotal);

                par.find('.fulloverlay button[data-action="confirm"]').on('click', { promise: thisAuctionConfirmPromise }, function (event) {
                    event.data.promise.resolve();
                    par.find('.fulloverlay').hide();
                });
                par.find('.fulloverlay button[data-action="cancel"]').on('click', function () {
                    par.find('.fulloverlay').hide();
                });
            } else {
                thisAuctionConfirmPromise.resolve();
            }
        }

        /*
    function thisAuctionConfirmPromiseResolved() {
      global_alert('Please wait while we submit your bids. Errors will show in red under each item.', 'success');

      $('.listingbox').each(function() {
        var $thisbtn = $(this).find('.actionbtn.exec'),
        $initconf = $thisbtn.data('conf');
        $forceconfirm = true;

        $thisbtn.click();

        $forceconfirm = false;
      });

      $('.placeallbids').hide();
    }
    */

        function thisAuctionConfirmPromiseResolved() {
            global_alert('Please wait while we submit your bids and offers. Confirmations will show under each item.', 'success');

            $('.dollar.pending').each(function () {
                var $bidparents = $(this).parents('.itempreview'),
                    $thisbtn = $bidparents.find('.actionbtn.exec'),
                    $initconf = $thisbtn.data('conf');
                // Special handler for counters
                if ($initconf != 'offer' && $initconf != 'bid') {
                    $thisbtn = $bidparents.find('.actionbutton.counter'),
                    $initconf = $thisbtn.data('conf');
                }

                $forceconfirm = true;
                $thisbtn.click();
                $forceconfirm = false;
            });

            $('.placeallbids').hide();
            $('.pendingbidcount').text('0').addClass('hide');
            $('.pendingbids.pendingtotal').val('$0');
        }

    });

    // bid now
    $(this).on('click', '.listingbox .exec', function (e) {
        e.preventDefault();
        var base = $(this).parents('.listingbox'),
            type = $(this).data('conf'),
            par = base.find('.actionfield[data-type="' + type + '"]'),
            confirmbox = par.find('.confirmbox'),
            context = par.data('context'),
            rawvalue = par.find('input.value').val(),
            minvalue = par.find('input.value').data('min'),
            value = par.find('input.value').val().replace(/[^0-9\.]/g, ''),
            notice = par.find('.notice'),
            messagebox = base.find('.message'),
            loader = base.find('.loader'),
            confirm = $(this).data('conf'),
            confmsg = par.find('.fulloverlay').find('.confirmbox .msg'),
            confmsgtext = confmsg.text(),
            dontshow = 0,
            softconfirm = false;

        par.find('input.value').removeClass('fail');
        par.find('.dollarError').hide();

        if (minvalue) {
            var minvalueraw = minvalue.replace(/[^0-9\.]/g, '');
        }

        if (value.length <= 0) {
            global_alert("Please enter an amount greater then $0.", 'error');
            return false;
        }

        if (type == 'bid' && minvalueraw && parseFloat(value) < parseFloat(minvalueraw)) {
            //global_alert("Please enter an amount greater then the minimum bid.", 'error');
            messagebox.text("Minimum bid or higher required.");
            messagebox.css('color', '#bd0000');
            return false;
        }

        if (confirmbox.find('input[name="f"]').val() == 'yes' && rawvalue === minvalue) {
            softconfirm = true;
        }

        if (confirmbox.find('input[name="f"]').val() == 'yes') {
            par.find('.dontshowagain').show();
        }

        loader.show();
        var thisAuctionConfirmPromise = $.Deferred();
        thisAuctionConfirmPromise.then(thisAuctionConfirmPromiseResolved, function () { loader.hide(); });

        if (confirm && !$forceconfirm && !softconfirm) {
            par.find('.fulloverlay').show();
            $('button[data-action="confirm"]').focus();
            confmsg.find('span').text(rawvalue);

            par.find('.fulloverlay button[data-action="confirm"]').on('click', { promise: thisAuctionConfirmPromise }, function (event) {
                if (confirmbox.find('input[name="dontshowbidconfirm"]').is(':checked') && rawvalue === minvalue && !$forceconfirm) {
                    $('input[name="f"]').val('yes');
                    dontshow = 1;
                }

                event.data.promise.resolve();
                par.find('.fulloverlay').hide();
            });

            par.find('.fulloverlay button[data-action="cancel"]').on('click', { promise: thisAuctionConfirmPromise }, function (event) {
                // par.find('input.value').val('$');
                par.find('.fulloverlay').hide();
                loader.hide();
                event.data.promise.reject();
            });
        } else {
            thisAuctionConfirmPromise.resolve();
            if ($forceconfirm) {
                setTimeout(function () {
                    loader.hide();
                }, 1000);
            }
        }
        function thisAuctionConfirmPromiseResolved(e) {
            notice.text('');

            var dataString = 'context=' + context + '&dontshow=' + dontshow + '&type=' + type + '&value=' + value + '&x_sign=' + x_sign + '&x_it=' + x_it;

            $.ajax({
                type: "POST",
                url: "/sec_ajax/itemaction",
                data: dataString,
                cache: false,
                success: function (response) {

                    var obj = $.parseJSON(response);

                    if (obj.REFR == '1') {
                        global_alert(obj.ERR, 'error');
                    }
                    else if (obj.FATALERR) {
                        messagebox.text(obj.FATALERR);
                        messagebox.css('color', '#bd0000');
                    }
                    else if (obj.ERR) {
                        messagebox.text(obj.ERR);
                        messagebox.css('color', '#bd0000');
                        refreshlisting(context);
                    }
                    else if (obj.GO == '1') {
                        if (obj.MSG) {
                            messagebox.text(obj.MSG);
                            if (obj.MSGC) {
                                messagebox.css('color', obj.MSGC);
                            }
                            else {
                                messagebox.css('color', '#49b94b');
                            }
                        }

                        if (type == 'offer') {
                            base.find('.counterform').remove();
                        }

                        par.find('input.value').removeClass('pending').removeClass('failed');

                        par.find('input.value').val('$');
                        //postbid(context);
                        refreshlisting(context, false);
                    }
                    loader.hide();
                }
            });
        }
    });

    window.onbeforeunload = function () {
        if ($('div[data-type="offer"] .dollar.value, div[data-type="bid"] .dollar.value').val() !== undefined && $('div[data-type="offer"] .dollar.value, div[data-type="bid"] .dollar.value').val() !== '$') {
            return "You have unsaved bids, are you sure you wish to leave?"; //With the exception for IE this message is not displayed to the user.
        }

    };

    // offer action
    $(this).on('click', '.listingbox .actionbutton[data-response]', function (e) {
        e.preventDefault();

        var base = $(this).parents('.listingbox'),
            type = $(this).data('response'),
            par = base.find('.rightside');

        if (par.length === 0) {
            par = base.find('.auctionactions');
        }

        var context = base.data('context'),
            offercontext = par.find('input[name="offercontext"]').val(),
            currentoffer = par.find('input[name="pendingoffer"]').val(),
            counteroffer = par.find('input[name="counteroffer"]').val(),
            offervalue = par.find('input[name="counteramnt"]').val(),
            notice = par.find('.notice'),
            messagebox = base.find('.message'),
            loader = base.find('.loader'),
            confirm = $(this).data('conf');
        overlaybox = par.find('.fulloverlay[data-conf="' + confirm + '"]');
        confmsg = overlaybox.find('.confirmbox .msg'),
        confmsgtext = confmsg.text(),
        rawvalue = '',
        offersubmit = '',
        stopexec = false;
        var localoffersubmit = '';

        if (type == 'counter') {
            localoffersubmit = offervalue.replace(/[^0-9\.]/g, '').trim();
            if (localoffersubmit <= 0 || localoffersubmit.length === 0) {
                global_alert('Please enter a valid counter offer amount.', 'error');
                stopexec = true;
            }
        }

        if (type == 'acceptcounter') {
            rawvalue = counteroffer;
        }
        else if (type == 'accept') {
            rawvalue = currentoffer;
        }
        else if (type == 'counter') {
            rawvalue = offervalue;
        }

        if (stopexec === false) {

            loader.show();
            var thisOfferConfirmPromise = $.Deferred();
            thisOfferConfirmPromise.then(thisOfferConfirmPromiseResolved, function () { loader.hide(); });

            if (confirm && !$forceconfirm) {
                overlaybox.show();
                if (rawvalue) {
                    confmsg.find('span').text(rawvalue);
                }

                overlaybox.find('button[data-action="confirm"]').on('click', { promise: thisOfferConfirmPromise }, function (event) {
                    event.data.promise.resolve();
                    overlaybox.hide();
                });
                overlaybox.find('button[data-action="cancel"]').on('click', function () {
                    overlaybox.hide();
                    loader.hide();
                    /* Do stuff to dismiss the overlay here */
                });
            } else {
                thisOfferConfirmPromise.resolve();
                loader.hide();
            }

            function thisOfferConfirmPromiseResolved() {
                notice.text('');
                var dataString = 'context=' + context + '&offercontext=' + offercontext + '&type=' + type + '&value=' + localoffersubmit + '&x_sign=' + x_sign + '&x_it=' + x_it;

                $.ajax({
                    type: "POST",
                    url: "/sec_ajax/offeraction",
                    data: dataString,
                    cache: false,
                    success: function (response) {
                        var obj = $.parseJSON(response);

                        if (obj.ERR) {
                            //notice.text(obj.ERR);
                            global_alert(obj.ERR, 'error');
                        }
                        else if (obj.GO == '1') {
                            if (obj.MSG) {
                                messagebox.text(obj.MSG);
                                if (obj.MSGC) {
                                    messagebox.css('color', obj.MSGC);
                                }
                                else {
                                    messagebox.css('color', '#49b94b');
                                }
                            }

                            if (type == 'acceptcounter') {
                                base.find('.counterform').remove();
                                base.find('.auctionactions').remove();
                                base.find('.btn.exec').remove();
                            }

                            base.find('.pendingofferform').remove();

                            //postbid(context);
                            refreshlisting(context, false);
                        }
                        loader.hide();
                    }
                });
            }

        }

    });

    $(this).on('click', '.listingbox .miscexec', function () {

        var base = $(this).parents('.listingbox'),
            context = base.data('context');

        var dataString = 'context=' + context + '&x_sign=' + x_sign + '&x_it=' + x_it;

        $.ajax({
            type: "POST",
            url: "/sec_ajax/miscaction",
            data: dataString,
            cache: false,
            success: function (response) {
                var obj = $.parseJSON(response);
                if (obj.GO == '1') {
                    global_alert(obj.MSG, 'success');
                }
                else {
                    global_alert(obj.MSG, 'error');
                }

            }
        });
    });

    $(this).on('finish.setred', '[data-countdown-ends]', function () {
        $(this).addClass('final');
    });

    $(this).on('finish.countdown', '[data-countdown-ends]', function () {
        var context = $(this).closest('.listingbox[data-type="auction"]').data('context');
        setTimeout(function () {
            // Auction Ended
            refreshlisting(context, true);
        }, 1000);
    });

    $(this).on('forcerefresh.countdown', '[data-countdown-ends]', function () {

        var $parent = context = $(this).closest('.listingbox[data-type="auction"]'),
            context = $parent.data('context');
        if (context) {
            refreshlisting(context);
        }
    });

    $(this).on('finish.countdown', '[data-countdown-ends]', function () {
        var context = $(this).closest('.listingbox[data-type="auction"]').data('context');
        setTimeout(function () {
            // Auction Ended
            refreshlisting(context, true);
        }, 1000);
    });

    // change page count
    $(this).on('change', 'select.perpage', function () {
        var $table = $(this).parents('.data-table').attr('data-table'),
            $val = $(this).val();

        var dataString = 'table=' + $table + '&val=' + $val + '&x_sign=' + x_sign + '&x_it=' + x_it;

        $.ajax({
            type: "POST",
            url: "/sec_ajax/changepagecount",
            data: dataString,
            cache: false,
            success: function () {
                location.reload();
            }
        });

    });

    // change listings grid
    $(this).on('click', '.changegrid', function () {
        var $table = $(this).parents('.data-table').attr('data-table'),
            $val = $(this).data('val');

        var dataString = 'table=' + $table + '&val=' + $val + '&x_sign=' + x_sign + '&x_it=' + x_it;

        $.ajax({
            type: "POST",
            url: "/sec_ajax/changelistingsgrid",
            data: dataString,
            cache: false,
            success: function () {
                location.reload();
            }
        });

    });

});

// START: FORM VALIDATION AND CONTROL, ERROR REPORTING

(function ($) {
    $.fn.message = function (message, type, delay) {
        var $this = $(this),
            alert_class;
        if (delay === undefined) { delay = 15000; }

        if (type) { alert_class = 'alert-' + type; }
        else { alert_class = 'alert-info'; }

        var element = $('<div/>').addClass('alert').addClass(alert_class).html(message).append('<a class="close" data-dismiss="alert">&times;</a>').prependTo($this);

        element.hide().slideDown();
        if (delay) { element.delay(delay).slideUp(function () { $(this).remove(); }); }
        return this;
    };
    $.message = function (message, type, delay) {
        $('#content > .container-fluid').message(message, type, delay);
    };

    $.process_json_response = function (data, target) {
        if (!target || !target.length) { target = $('#content > .container-fluid'); }
        if (data.msgs && data.msgs.error) {
            $.each(data.msgs.error, function (i, value) {
                target.message(value, 'error');
            });
        }
        if (data.msgs && data.msgs.success) {
            $.each(data.msgs.success, function (i, value) {
                target.message(value, 'success');
            });
        }
        if (data.msgs && data.msgs.info) {
            $.each(data.msgs.info, function (i, value) {
                target.message(value, 'info');
            });
        }
    };

    function display_form_errors($this, errors) {
        var prefix = $this.data('prefix') || '';
        var regexp = new RegExp("^" + prefix + "control_(.*)$");
        $this.find('.control-group.error').each(function () {
            var name = $(this).prop('id').replace(regexp, '$1');
            if (!errors[name]) {
                $(this).removeClass('error').find('.controls > .help-error').slideUp(function () { $(this).remove(); });
            }
        });
        $.each(errors, function (key, value) {
            var target = $this.find('#' + prefix + 'control_' + key);
            target.addClass('error');
            if (!target.find('.controls > .help-error').length) { $('<div/>').addClass("help-block").addClass("help-error").text(value.join(', ')).appendTo(target.find('.controls')).hide().slideDown(); }
            else { target.find('.controls > .help-error').text(value.join(', ')); }
        });
    }

    function form_submit(e) {
        var $this = $(this);
        e.preventDefault();

        var $submit = $this.find('input[type=submit], button[type=submit]');
        $submit.prop('disabled', true);

        $.ajax({
            url: $this.prop('action'),
            data: $this.serialize() + "&x_sign=" + x_sign + "&x_it=" + x_it,
            type: 'POST',
            headers: { 'DZ-Output': 'json' },
            success: function (data) {
                if (data.success) {
                    $.process_json_response(data);
                    $this.parents('.modal').modal('hide');
                    $('#main').trigger('reload');
                }
                else {
                    $.process_json_response(data, $this.find('.modal-body'));
                    display_form_errors($this, data.errors || {});
                }
                $submit.prop('disabled', false);
            },
            error: function () {
                $this.find('.modal-body').message('Sorry, but we experienced an error while trying to process this form.', 'error');
                $submit.prop('disabled', false);
            }
        });
    }

    $.fn.form = function () {
        this.on('submit', form_submit);
        return this;
    };
    $.fn.validate = function () {
        var valid = true;
        $(this).find('[data-validate]').each(function () {
            var $this = $(this);
            var passed = true;
            var message = null;
            var validations = $this.data('validate') || '';
            $this.find('input[type=text], input[type=password], textarea, select, input[type=checkbox]').each(function () {
                if ($(this).parents('.chosen-container').length) { return; }
                validations.split(',').forEach(function (validation) {
                    if (validation === 'charlimit') {
                        var datalimit = $(this).attr('data-charlimit');
                        if ($(this).val().length > datalimit) {
                            passed = false;
                            message = "Character limit exceeded. Limit: " + datalimit;
                        }
                    }
                    if (validation === 'required') {
                        if ($(this).attr('type') == 'checkbox' && !$(this).is(':checked')) {
                            passed = false;
                            message = "This field is required.";
                        }
                        else if ($(this).val() === '') {
                            passed = false;
                            message = "This field is required.";
                        }
                    }
                    if ($(this).val() !== '' && validation === 'email') {
                        if (!(/[^@]+@[^@]+\.[^@]+/.test($(this).val()))) {
                            passed = false;
                            message = "Please enter a valid email.";
                        }
                    }
                }, this);
            });
            if (passed) {
                $this.removeClass('error');
                $this.find('.help-error').remove();
            }
            else {
                $this.addClass('error');
                $this.find('.help-error').remove();
                $this.find('.controls').append($('<span>').addClass('help-block').addClass('help-error').text(message));
                $('html, body').animate({
                    scrollTop: $('.error:visible:first').offset().top
                }, 1000);
            }
            valid = valid && passed;
        });
        return valid;
    };
})(jQuery);

function link_click(event) {
    var $this = $(this);
    var message = $this.data('confirm') === true ? 'Are you sure you want to delete this item?' : $(this).data('confirm');
    if ($this.data('remote')) {
        if (!$this.data('confirm') || window.confirm(message)) {
            $.ajax({
                url: $this.prop('href'),
                headers: { 'DZ-Output': 'json' },
                success: function (data) {
                    $.process_json_response(data, $this.parents('.modal-body'));
                }
            });
        }
        return false;
    }
    else if ($this.data('confirm')) {
        return window.confirm(message);
    }
}

function display_modal(e) {

    var url = $(this).prop('href').split('#');

    var that = this;
    $.ajax({
        url: url[0],
        headers: { 'DZ-Output': 'modal' },
        success: function (data) {
            var $elements = output_modal.call(that, data);

            if (url[1]) {
                $elements.find('.nav-tabs a[href="#' + url[1] + '"]').tab('show');
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.responseText && jqXHR.responseText.length > 0) {
                output_modal.call(that, jqXHR.responseText);
            }
        }
    });

    e.preventDefault();
}

function validate_form(e) {
    if (!$(this).validate()) {
        e.preventDefault();
    }
}

$.fn.initialize = function () {

    //this.find('select.chosen').chosen({ allow_single_deselect: true });
    //this.find('select.chosen-ajax.chosen-users').ajaxChosen({ headers: { 'DZ-Output': 'json' }, type: 'POST', url:'/admin/search/users' }, { }, { allow_single_deselect: true });

    //this.find('.js-batch').batch_add();
    //this.find('.js-paginator').paginator();
    //this.find('.activity-wall').activity_wall();
    this.find('.js-form').form();

    //this.find('.js-data-table-export').click(export_table_dialog);
    //this.find('.js-print-dialog').click(print_dialog);
    this.find('.js-validate').on('submit', validate_form);

    //this.find('textarea.ckeditor').ckeditor();

    //this.find('abbr[title]').tooltip();

    //this.find('.js-type-memorize').typeahead(memorize_typeahead).attr('autocomplete', 'off');

    //this.find('.js-type-memorize-single').typeahead(memorize_typeahead_single).attr('autocomplete', 'off');

    //this.find('.js-select-all').change(select_all_change);

    return this;
};

function reload_main() {
    var $this = $(this);
    var pages = $(this).data('pages');
    var query = document.location.search;

    if (pages) {
        if (query === "") { query = "?pages=" + pages; }
        else if (query.match(/(\?|&)pages=(.*?)(&|$)/)) { query = query.replace(/(\?|&)pages=(.*?)(&|$)/, '$1pages=' + pages + '$3'); }
        else { query = query + "&pages=" + pages; }
    }

    var scroll = $(window).scrollTop();

    $.ajax({
        url: document.location.pathname + query,
        headers: { 'DZ-Output': 'reload' },
        success: function (data) {
            var contents = $($.parseHTML(data));

            $this.html(contents);
            contents.initialize();
            $(window).scrollTop(scroll);
        }
    });
}

$(document)
    .on('click', '[data-modal]', display_modal)
    .on('click', '[data-confirm], [data-remote]', link_click)
    .on('reload', '#main', reload_main)
    .initialize();

$(function () {
    var hash = window.location.hash;
    hash && $('ul.nav a[href="' + hash + '"]').tab('show');

    $('.nav-tabs a').click(function (e) {
        $(this).tab('show');
        var scrollmem = $('body').scrollTop();
        window.location.hash = this.hash;
        $('html,body').scrollTop(scrollmem);
    });
});

if (window.location.hash != "") {
    $('.nav-tabs a[href="' + window.location.hash + '"]').tab('show');
}

$(function () {
    var leftScrollValue = -180;
    var rightScrollValue = 180;

    $('#browse-sort-drop').on('change', function () {
        var url = '';
        var href = document.location.href;
        var noSortTypeUrl = window.location.href.split('sort_type');

        if (href.indexOf('?') > -1) {
            if (href.indexOf('sort_type') > 1) {
                url = setUrlParameter('sort_type', $(this).val());
            } else {
                url = href + "&sort_type=" + $(this).val();
            }
        } else {
            if (href.indexOf('sort_type') > 1) {
                url = setUrlParameter('sort_type', $(this).val());
            } else {
                url = href + "?sort_type=" + $(this).val();
            }
        }
        window.location.href = url;
    });

    $('.dashboard-head').on('click', function () {
        var name = $(this).attr('data-name');
        var $filterSection = $('.filtersec[data-target=' + name + ']');
        if ($filterSection.is(':visible')) {
            $filterSection.hide();
        } else {
            $filterSection.show();
        }
    });

    $('input[name=search]').on('focus', function () {
        $('.topactionbar').addClass('active');
    /*$('.topactionbar').css('width', '900px');
    $('#advanced-search').css('right', '330px');
    $('#advanced-search').show();
$('.topactionbar .baractions').hide();
    $(this).css('width', '500px');*/
    });

    $(document).click(function (event) {
        if (!$(event.target).closest('.topactionbar').length) {
            $('.topactionbar').removeClass('active');
            /*$('.topactionbar').css('width', '');
     $('#advanced-search').css('right', '490px');
     $('#advanced-search').hide();
$('.topactionbar .baractions').show();
     $('input[name=search]').css('width', '');*/
        }
    });

    $('#advanced-search').on('click', function () {

        if ($('#advanced-search-box').is(':visible')) {
            $('#advanced-search-box').hide();
        } else {
            $('#advanced-search-box').show();
        }
    });

    // $(".fancybox").fancybox();

    $('.stock-item-arrow-left').on('click', function () {
        $(".inner-stockitem-next-container").scrollLeft(leftScrollValue);
        if (leftScrollValue != -180) {
            rightScrollValue = leftScrollValue + 180;
            leftScrollValue -= 180;
        }
    });

    $('.stock-item-arrow-right').on('click', function () {
        var listingsCount = $(this).attr('data-listings-count');
        var upperValue = listingsCount * 180;
        $(".inner-stockitem-next-container").scrollLeft(rightScrollValue);
        if (rightScrollValue != upperValue) {
            leftScrollValue = rightScrollValue - 180;
            rightScrollValue += 180;
        }
    });
    $('body .next_prev_arrow').on('click', function () {
        var res = '';
        $.ajax({
            url: '/sec_ajax/getitems',
            data: { id: $(this).data('id'), char: $(this).data('char') },
            type: 'POST',
            success: function (data) {
                data = JSON.parse(data);
                $.each(data, function (index, value) {

                    res += '<div class="col-new ' + (value.id == $('.next_prev_res').data('id') ? 'next_prev_current' : value.id) + '">'
            + '<div class="next_prev_pointer"></div>'
            + '<a href="/item/' + value.id + '"><img style="width: 100%;height: auto;" src="' + value.img + '"/><a>'
            + '<div style="text-align: center">'
            + '<a href="/item/' + value.id + '">'
            + '<div class="next_prev_title">' + value.title + '</div>'
            + '</a>'
            + '<div class="next_prev_bid">Current Bid: $1</div>'
            + '</div>'
            + '</div>';
                });
                $('.next_prev_arrow.stock-item-arrow-right').data('id', data[4].id);
                $('.next_prev_arrow.stock-item-arrow-left').data('id', data[0].id);
                $('.next_prev_res').html(res);

            }
        });
    });
    jQuery.expr.filters.offscreen = function (el) {
        var rect = el.getBoundingClientRect();
        return (
            (rect.x + rect.width) < 0
      || (rect.y + rect.height) < 0
      || (rect.x > window.innerWidth || rect.y > window.innerHeight)
        );
    };
    $('.mainimg.hoverbox').on('mouseover', function () {
        var leftoffset = ($(this).offset().left - $('.main').offset().left) + $(this).next('.preview').width() + 100;

        if (leftoffset > $('.main').innerWidth()) { // prevent hoverbox from hanging off the page
            $(this).next('.preview').addClass('top-100');
        }
    });

});

function openNav(event) {
    event.preventDefault();
    $('.filters').css({
        margin: '0',
        position: 'absolute',
        'z-index': '99999',
        top: '0',
        left: '0',
        height: '100%',
        'overflow-x': 'hidden',
        'overflow-y': 'scroll',
        'background-color': '#0e75cd'
    });
    $('.listingsgrid').css({
        opacity: '0.2'
    });
    $('.filters').show();
}

function closeNav() {
    $('.listingsgrid').css({
        opacity: '1'
    });
    $('.filters').hide();
}
// END: FORM VALIDATION AND CONTROL, ERROR REPORTING

$(window).resize(function () {
    var Win_width = $(window).width();
    if (Win_width >= 950) {
        $('#filters_menu').hide();
        $('.filters').show();
        $('.listingsgrid').css({
            opacity: '1'
        });
    } else {
        $('#filters_menu').show();
    }

    if ($('.globaloverlay.lightboxversion').length) {
        $('.globaloverlay.lightboxversion').css({ height: $(document).height() });
    }
});

$(document).ready(function () {
    if ($('.browselistings').length) {
        setTimeout(function(){ adjustheights(); }, 1000);
    }
    $(".loader img").on("error", function(){
        if ($(this).attr('src') !== '/img/loader-ie.gif') {
            $(this).attr('src', '/img/loader-ie.gif');
        }
    });
});

function countrySelected() {
    var country = $('#user_control_country select').val();
    if (country == "United States") {
      $('#user_control_state').show();
      $('#user_control_state select').attr('name','state');
      $('#user_control_state_open').hide();
      $('#user_control_state_open input').attr('name','state_open');
    } else {
      $('#user_control_state').hide();
      $('#user_control_state select').attr('name','state_select');
      $('#user_control_state_open').show();
      $('#user_control_state_open input').attr('name','state');
    }
}

$(document).ready(function () {
  $('#user_control_state').hide();
  $('#user_control_state input').attr('name','state_select');
  $('#user_control_state_open input').attr('name','state');
  $('body').on('change', '#user_control_country select', function () {
    countrySelected();
  });
});
